// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"64900ad1","151":"11256a4a","189":"b806dd36","326":"f08a65e0","426":"df1ddfa9","444":"8fcbe942","447":"fa834553","464":"526de8ab","472":"2f3f9854","825":"2333f24c","938":"a1961d1b"}[chunkId] + ".chunk.js";
};